<template> </template>

<script>
import { mapActions } from "vuex";

export default {
  name: "Base",
  methods: {
    ...mapActions("common", ["setLoading"])
  },
  mounted() {
    this.setLoading(false);
  }
};
</script>
